import React, { ReactElement } from "react";
import styles from "./styles.module.scss";
interface IProps {
  title: string;
  src: string;
  height?: string
  scrolling?: string
  width?: string
  caller?: string
}
function Iframe({ title, src, height, scrolling = "no", width = "100%" }: IProps): ReactElement {
  return <iframe
    id="i_frame"
    title={title}
    src={src}
    scrolling={scrolling}
    width={width}
    height={height}
    className={styles.iFrame}
  />;
}

export default Iframe;
